import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayDanhSachNguoiDung(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.AUTH.PERMISSION}?appCode=${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiLayHoTenCanBo = () => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.LAY_HO_TEN_CAN_BO)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
